import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/Sidebar/Dark_logo.png";

const LegalPage = ({ title, effectiveDate, children }) => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;

    const sectionId = decodeURIComponent(hash.slice(1));
    const animationFrame = window.requestAnimationFrame(() => {
      document.getElementById(sectionId)?.scrollIntoView({
        block: "start",
      });
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [hash]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#172033]">
      <header className="border-b border-[#D8DEE8] bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4 sm:px-6">
          <Link to="/" className="inline-flex items-center">
            <img
              src={logo}
              alt="CoursePivot"
              className="h-12 w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="rounded-md border border-[#253B80] px-4 py-2 text-sm font-semibold text-[#253B80] hover:bg-[#EFF4FF]"
          >
            Dashboard
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6">
        <div className="mb-8">
          <p className="mb-2 text-sm font-semibold uppercase tracking-wide text-[#C8490A]">
            CoursePivot
          </p>
          <h1 className="text-3xl font-bold text-[#172033] sm:text-4xl">
            {title}
          </h1>
          <p className="mt-3 text-sm text-[#64748B]">
            Effective Date: {effectiveDate}
          </p>
        </div>

        <article className="space-y-8 rounded-lg border border-[#D8DEE8] bg-white p-5 leading-7 shadow-sm sm:p-8">
          {children}
        </article>
      </main>
    </div>
  );
};

export default LegalPage;
